import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import DataDisplay, { DataDisplayVariant } from '@sharedCR/coreDesignSystem/DataDisplay';
import PropTypes from 'prop-types';

import { PREVIEW_COPY } from '../../previewGeneration.constants';
import { PreviewStepTestIds } from '../../PreviewStep.testIds';

import { cardStyles, getTileStyles, gridStyles, titleStyles } from './KeyNumbersRail.styles';

const KeyNumbersRail = ({ keyNumbers }) => (
  <Box data-testid={PreviewStepTestIds.KEY_NUMBERS} sx={cardStyles}>
    <Typography sx={titleStyles} variant="regular12">
      {PREVIEW_COPY.keyNumbersTitle}
    </Typography>
    <Box sx={gridStyles}>
      {keyNumbers.map(({ id, title, value, type, highlight }) => (
        <Box
          data-testid={PreviewStepTestIds.getKeyNumberTestId(id)}
          key={id}
          sx={getTileStyles(highlight)}
        >
          <DataDisplay
            title={title}
            type={type}
            value={value}
            variant={DataDisplayVariant.STYLE_A}
          />
        </Box>
      ))}
    </Box>
  </Box>
);

KeyNumbersRail.propTypes = {
  keyNumbers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      type: PropTypes.string,
      highlight: PropTypes.bool,
    }),
  ).isRequired,
};

export default memo(KeyNumbersRail);
